import { UntypedFormGroup, Validators } from '@angular/forms'
import { isArray } from 'lodash'

export const resetFormControl = (formGroup: UntypedFormGroup): (controlNameOrNames: string | string[]) => void => {
  return (controlNameOrNames): void => {
    (isArray(controlNameOrNames) ? controlNameOrNames : [controlNameOrNames])
      .forEach((name: string | string[]) => {
        const control = formGroup.get(name)
        if (!control) {
          return
        }

        control.setValue(null)
        control.setValidators(null)
        control.updateValueAndValidity()
      })
  }
}

export const setFormControlAsRequired = (formGroup: UntypedFormGroup): (controlName: string, value?: any) => void => {
  return <T>(controlName: string, value?: T): void => {
    const control = formGroup.get(controlName)
    if (!control) {
      return
    }

    if (value) {
      control.setValue(value)
    }

    control.setValidators([Validators.required])
    control.updateValueAndValidity()
  }
}
